import { render, staticRenderFns } from "./ReceiveShippingModal.vue?vue&type=template&id=508a8392&scoped=true"
import script from "./ReceiveShippingModal.vue?vue&type=script&lang=js"
export * from "./ReceiveShippingModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiveShippingModal.vue?vue&type=style&index=0&id=508a8392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a8392",
  null
  
)

export default component.exports